import { createContext, useContext, ReactNode, useEffect } from 'react';
import { translations, Language, TranslationKey } from '@/i18n/translations';
import { useSettings } from '@/hooks/useSettings';

interface LanguageContextType {
  language: Language;
  t: (key: TranslationKey) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: ReactNode }) {
  const { settings } = useSettings();
  const language = (settings?.language as Language) || 'pt-BR';

  const t = (key: TranslationKey): string => {
    return translations[language]?.[key] || translations['pt-BR'][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}
